module.exports = __webpack_public_path__ + "img/sd.8f2db906.png";